import React from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import routes from "../../../assets/apiRoutes.json";
import TextBox from 'devextreme-react/text-box';
import axios from "axios";
import data from "../../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';
import ungroupedData from '../../../const/StatesList';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import {
    Validator,
    RequiredRule,
    StringLengthRule,
    EmailRule,
    PatternRule,
} from 'devextreme-react/validator';
import ValidationSummary from 'devextreme-react/validation-summary';
let accessToken = '';
const shipViaSelectBox = React.createRef();
const taxCodeSelectBox = React.createRef();

class Consignee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            identityid: "",
            telephone1: "",
            contactname: "",
            name: "",
            telephone2: "",
            contactid: "",
            address1: "",
            contactphone: "",
            email1: "",
            address2: "",
            cellphone1: "",
            shipvia: "",
            shipviarowid: "",
            city: "",
            state: "",
            country: "",
            fax1: "",
            taxcode: "",
            taxcoderowid: "",
            zip: "",
            comment: "",
            directions: ""
        };
        accessToken = props.oidc.user.access_token;
        this.SaveRecord = this.SaveRecord.bind(this);
        this.TaxCodeChanged = this.TaxCodeChanged.bind(this);
        this.ShipviaChanged = this.ShipviaChanged.bind(this);
        this.LoadTaxCodes = this.LoadTaxCodes.bind(this);
        this.LoadShipViaCodes = this.LoadShipViaCodes.bind(this);
        this.LoadIdentityId = this.LoadIdentityId.bind(this);
        this.reset = this.reset.bind(this);
        this.stateLst = new DataSource({
            store: {
                type: 'array',
                data: ungroupedData,
                key: 'stateId',
            },
            group: 'countryName',
        });
    }

    componentDidMount() {
        this.LoadIdentityId();
        this.LoadTaxCodes();
        this.LoadShipViaCodes();
    }

    LoadIdentityId() {
        var request = {
            Module: "WM",
            TransactionType: "V"
        };
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.generateTransaction}`, request,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                this.setState({ identityid: response.data })
            })
            .catch((err) => {
                console.log(err, "Error in loading IdentityId");
            });
    }

    LoadShipViaCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Carrier.GetShipVia}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let identityDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                shipViaSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                shipViaSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            })
            .catch((err) => {
                console.log(err, "Error in loading Ship via codes");
            });
    }

    LoadTaxCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.TaxCode.GetTaxCodes}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let identityDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                taxCodeSelectBox.current.instance().option(
                    "dataSource",
                    identityDataStore
                );
                taxCodeSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            })
            .catch((err) => {
                console.log(err, "Error in loading Tax codes");
            });
    }

    ShipviaChanged(e) {
        this.setState({
            shipviarowid: e.value,
        });
    }

    TaxCodeChanged(e) {
        this.setState({
            taxcoderowid: e.value,
        });
    }

    reset() {
        this.state.identityid = "";
        this.state.telephone1 = "";
        this.state.contactname = "";
        this.state.name = "";
        this.state.telephone2 = "";
        this.state.contactid = "";
        this.state.contactphone = "";
        this.state.email1 = "";
        this.state.address1 = "";
        this.state.address2 = "";
        this.state.cellphone1 = "";
        this.state.shipvia = "";
        this.state.shipviarowid = "";
        this.state.city = "";
        this.state.state = "";
        this.state.country = "";
        this.state.fax1 = "";
        this.state.taxcode = "";
        this.state.taxcoderowid = "";
        this.state.comment = "";
        this.state.directions = "";
    }
    SaveRecord(e) {
        e.preventDefault();

        var rqst = this.state;
        axios.post(`${window._env_.REACT_APP_APIS}/${data.Consignee.InsertConsignee}`, rqst,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data == "Consignee already exist.") {
                    notify({
                        message: 'Record Already Exists!',
                        width: 100,
                    }, 'error', 2000);
                }
                else {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                    this.props.parentCallback(res.data);
                    this.reset();
                }
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
            });
    }
    render() {
        return (
            <div>
                <form onSubmit={(e) => this.SaveRecord(e)}>
                    <div className="row">
                        <div className="col-md-3">
                            <TextBox
                                id="consigneeidentityid"
                                className="field-label-required-red"
                                type="text"
                                placeholder="Enter Identity ID"
                                onValueChanged={(data) => this.setState({ identityid: data.value })}
                                name="identityid"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Identity ID:"
                                value={this.state.identityid}
                            >
                                <Validator>
                                    <RequiredRule message="Identityid is required" />
                                    <StringLengthRule message="Identity id must have at least 3 chracters and maximum 12." trim={true} min={3} max={12} />
                                </Validator>
                            </TextBox>
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneetelephone1"
                                type="text"
                                placeholder="Enter Telephone - 1"
                                onValueChanged={(data) => this.setState({ telephone1: data.value })}
                                name="telephone1"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Telephone - 1:"
                                value={this.state.telephone1}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneecontactname"
                                type="text"
                                placeholder="Enter Contact Name"
                                onValueChanged={(data) => this.setState({ contactname: data.value })}
                                name="contactname"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Contact Name:"
                                value={this.state.contactname}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneename"
                                type="text"
                                placeholder="Enter Name"
                                onValueChanged={(data) => this.setState({ name: data.value })}
                                name="name"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Name:"
                                className="field-label-required-red"
                                value={this.state.name}>
                                <Validator>
                                    <RequiredRule message="Name is required." />
                                    <StringLengthRule message="Name must have at least 3 chracters and maximum 40" min={3} max={40} />
                                </Validator>
                            </TextBox>
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-3">
                            <TextBox
                                id="consigneetelephone2"
                                type="text"
                                placeholder="Enter Telephone - 2"
                                onValueChanged={(data) => this.setState({ telephone2: data.value })}
                                name="telephone2"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Telephone - 2:"
                                value={this.state.telephone2}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneecontactid"
                                type="text"
                                placeholder="Enter Contact Id"
                                onValueChanged={(data) => this.setState({ contactid: data.value })}
                                stylingMode='outlined'
                                labelMode="static"
                                label="Contact ID:"
                                value={this.state.contactid}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneeaddress1"
                                type="text"
                                placeholder="Enter Address"
                                onValueChanged={(data) => this.setState({ address1: data.value })}
                                stylingMode='outlined'
                                labelMode="static"
                                label="Address - 1:"
                                className="field-label-required-red"
                                value={this.state.address1}>
                                <Validator>
                                    <RequiredRule message="Address - 1  is required." />
                                    <StringLengthRule message="Address - 1 can have maximum 40 chracters." min={3} max={40} />
                                </Validator>
                            </TextBox>
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneeContactPhone"
                                type="text"
                                placeholder="Enter Contact phone"
                                onValueChanged={(data) => this.setState({ contactphone: data.value })}
                                name="contactphone1"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Contact Phone:"
                                value={this.state.contactphone}
                            />
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-3">
                            <TextBox
                                id="consigneemail1"
                                type="text"
                                placeholder="Enter Contact Id"
                                onValueChanged={(data) => this.setState({ email1: data.value })}
                                name="email1"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Email - 1:"
                                value={this.state.email1}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneeaddress2"
                                type="text"
                                placeholder="Enter Address"
                                onValueChanged={(data) => this.setState({ address2: data.value })}
                                stylingMode='outlined'
                                labelMode="static"
                                label="Address - 2:"
                                value={this.state.address2}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneecellphone1"
                                type="text"
                                placeholder="Enter Cellphone - 1"
                                onValueChanged={(data) => this.setState({ cellphone1: data.value })}
                                name="cellphone1"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Cellphone - 1:"
                                value={this.state.cellphone1}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectBox
                                ref={shipViaSelectBox}
                                searchEnabled={true}
                                placeholder="Select Ship via"
                                onValueChanged={this.ShipviaChanged}
                                displayExpr="name"
                                valueExpr="id"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Ship Via - 1:"
                                acceptCustomValue={true}
                            />
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-3">
                            <TextBox
                                id="consigneecity"
                                type="text"
                                placeholder="Enter City"
                                onValueChanged={(data) => this.setState({ city: data.value })}
                                stylingMode='outlined'
                                labelMode="static"
                                label="City:"
                                value={this.state.city}
                                className="field-label-required-red"
                            >
                                <Validator>
                                    <RequiredRule message="City is required." />
                                    <StringLengthRule message="City can have maximum 30 chracters." min={3} max={40} />
                                </Validator>
                            </TextBox>
                        </div>
                        <div className="col-md-3">
                            <SelectBox
                                dataSource={this.stateLst}
                                valueExpr="stateId"
                                grouped={true}
                                searchEnabled={true}
                                searchMode={'contains'}
                                searchExpr={['stateCode', 'stateName']}
                                minSearchLength={0}
                                onValueChanged={(data) => {
                                    let arr = data.value.split(',');
                                    this.setState({ state: arr[0], country: arr[1] })
                                }}
                                stylingMode='outlined'
                                labelMode="static"
                                label="State:"
                                className="field-label-required-red"
                                displayExpr="stateCode">
                                <Validator>
                                    <RequiredRule message="State is required." />
                                </Validator>
                            </SelectBox>
                        </div>
                        <div className="col-md-3">
                            <TextBox
                                id="consigneefax"
                                type="text"
                                placeholder="Enter Fax - 1"
                                onValueChanged={(data) => this.setState({ fax1: data.value })}
                                name="fax1"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Fax - 1:"
                                value={this.state.fax1}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectBox
                                ref={taxCodeSelectBox}
                                searchEnabled={true}
                                placeholder="Select Tax Code"
                                onValueChanged={this.TaxCodeChanged}
                                displayExpr="name"
                                valueExpr="id"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Tax Code:"
                                acceptCustomValue={true}
                            />
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-3">
                            <TextBox
                                id="consigneezip"
                                type="text"
                                placeholder="Enter Zip"
                                onValueChanged={(data) => this.setState({ zip: data.value })}
                                name="zip"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Zip:"
                                className="field-label-required-red"
                                value={this.state.zip}>
                                <Validator>
                                    <RequiredRule message="Zip is required." />
                                    {this.state.country == "USA" && (
                                        <PatternRule message="This field must be 5 or 9 digit ZIP Code (like 02354 or 94043-1245)." pattern={'^[0-9]{5}(?:-[0-9]{4})?$'} />
                                    )}
                                </Validator>
                            </TextBox>
                        </div>
                        <div className="col-md-9">
                            <TextBox
                                id="consigneecomment"
                                type="text"
                                placeholder="Enter Comment"
                                onValueChanged={(data) => this.setState({ comment: data.value })}
                                name="cncomment"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Comment:"
                                value={this.state.comment}
                            />
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-12">
                            <TextBox
                                id="consigneedirections"
                                type="text"
                                placeholder="Enter Directions"
                                onValueChanged={(data) => this.setState({ directions: data.value })}
                                name="directions"
                                stylingMode='outlined'
                                labelMode="static"
                                label="Directions:"
                                value={this.state.directions}
                            />
                        </div>
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-12">
                            <Button
                                className="accordianButton" text="Save Record" type="default"
                                useSubmitBehavior={true}
                                // onClick={this.SaveRecord}
                                stylingMode="contained">
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(Consignee);